import React from 'react'
import styled, { keyframes } from 'styled-components';
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import { educations } from '../../data/constants';
import EducationCard from '../Cards/EducationCard';

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 60px 20px 80px 20px;

  @media (max-width: 960px) {
    padding: 40px 16px;
  }
`;

const Wrapper = styled.div`
  max-width: 1100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

const Title = styled.h2`
  font-size: 48px;
  font-weight: 700;
  text-align: center;
  margin-top: 20px;
  background: ${({ theme }) => theme.gradient_text};
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmer} 3s linear infinite;

  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  max-width: 600px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const TimeLineSection = styled.div`
  width: 100%;
  max-width: 1000px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  
  .MuiTimeline-root {
    padding: 6px 16px;
  }
  
  .MuiTimelineConnector-root {
    background: ${({ theme }) => theme.gradient_primary};
  }
  
  .MuiTimelineDot-root {
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 10px ${({ theme }) => theme.shadow_primary};
  }

  @media (max-width: 768px) {
    .MuiTimeline-root {
      padding: 0;
    }

    .MuiTimelineItem-root::before {
      display: none;
    }
  }
`;

const Education = () => {
  return (
    <Container id='education'>
      <Wrapper>
        <Title>Education</Title>
        <Desc>My academic background and qualifications</Desc>
        <TimeLineSection>
          <Timeline>
            {educations.map((education, index) => (
              <TimelineItem key={index}>
                <TimelineSeparator>
                  <TimelineDot variant="outlined" color='secondary' />
                  {index !== educations.length - 1 && (
                    <TimelineConnector style={{ background: 'linear-gradient(180deg, #37c164 0%, #2da855 50%, #258a47 100%)' }} />
                  )}
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <EducationCard education={education} />
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </TimeLineSection>
      </Wrapper>
    </Container>
  )
}

export default Education